<template>
  <b-nav-item
      v-if="canSee"
      class="calendar-requests-btn"
      v-b-tooltip.hover.bottom
      :title="pendingCount > 0 ? pendingCount + ' ' + msg('Pending requests') : msg('Calendar')"
      @click="goToCalendar"
  >
    <feather-icon
        :badge="badgeText"
        badge-classes="bg-danger"
        class="text-body"
        icon="CalendarIcon"
        size="21"
    />
  </b-nav-item>
</template>

<script>
import {BNavItem, VBTooltip} from 'bootstrap-vue'

const REFRESH_MS = 120000 // poll pending booking requests every 2 minutes

export default {
  name: 'CalendarRequestsButton',
  components: {BNavItem},
  directives: {'b-tooltip': VBTooltip},
  data() {
    return {
      timer: null,
    }
  },
  computed: {
    canSee() {
      try {
        return this.$store.getters['user/canRead']('appointments')
      } catch (e) {
        return false
      }
    },
    pendingCount() {
      return this.$store.getters['appointment/getPendingCount']
    },
    badgeText() {
      if (!this.pendingCount) return null
      return this.pendingCount > 99 ? '99+' : String(this.pendingCount)
    },
  },
  mounted() {
    if (this.canSee) {
      this.$store.dispatch('appointment/fetchPendingCount')
      this.timer = setInterval(() => {
        this.$store.dispatch('appointment/fetchPendingCount')
      }, REFRESH_MS)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    goToCalendar() {
      if (this.$route.name !== 'AppointmentCalendar') {
        this.$router.push({name: 'AppointmentCalendar'}).catch(() => {})
      }
    },
  },
}
</script>
